<template>
  <v-layout row v-if="isManualSaleEnabled">
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="headline">Pagamento</span>
        </v-card-title>
        <v-card-title v-if="newPaymentError">
          <v-alert :value="true" color="error" icon="warning" outline>
            <p>Erro ao gerar pagamento!</p>
            <p>Código: {{ response.errors[0].response_code }}</p>
            <p>Detalhe: {{ response.errors[0].response_code_detail }}</p>
          </v-alert>
        </v-card-title>
        <v-card-title v-if="newPaymentStatus">
          <v-alert :value="true" color="success" icon="check_circle" outline>
            Pagamento criado com sucesso, com ID: {{ response[0].id }}
          </v-alert>
        </v-card-title>
        <v-progress-linear :indeterminate="isLoading"></v-progress-linear>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-xl fluid>
            <v-layout wrap>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Valor"
                  v-model.lazy="amount"
                  v-money="money"
                  :rules="amountRules"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-select
                  v-model.lazy="paymentOptionCode"
                  :hint="`${parcels[0].name}`"
                  :items="parcels"
                  item-text="name"
                  item-value="value"
                  label="Parcelamento"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model.lazy="cardHolderName"
                  :rules="nameRules"
                  label="Nome impresso no cartão"
                  required
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  id="cardNumber"
                  type="password"
                  v-model.lazy="pan"
                  label="Número do cartão"
                  maxLength="16"
                  :counter="16"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-select
                  v-model.lazy="expiryMonth"
                  :hint="`${months[0].name}`"
                  :items="months"
                  item-text="name"
                  item-value="value"
                  label="Mês de vencimento"
                  persistent-hint
                  return-object
                  single-line
                ></v-select> </v-flex
              ><br />
              <v-flex xs12 sm2>
                <v-select
                  v-model.lazy="expiryYear"
                  :hint="`${years[0].name}`"
                  :items="years"
                  item-text="name"
                  item-value="value"
                  label="Ano de vencimento"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2>
                <v-select
                  v-model.lazy="scheme"
                  :hint="`${schemes[0].name}`"
                  :items="schemes"
                  item-text="name"
                  item-value="value"
                  label="Bandeira"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field
                  id="securityCode"
                  type="password"
                  v-model.lazy="securityCode"
                  :rules="codeRules"
                  label="Código de segurança | CVC"
                  maxLength="3"
                  :counter="3"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="validate">Enviar</v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
  <v-container grid-list-md text-xs-center class="background-billing" v-else>
    <v-layout row wrap class="align-bill">
      <v-card class="mx-auto" max-width="600" style="margin-top: 50px;">
        <v-card-text class="text-center">
          <v-icon size="64" color="grey lighten-1" class="mb-4">block</v-icon>
          <h2 class="headline mb-3">Sistema de Venda Digitada Desabilitado</h2>
          <p class="body-1 grey--text text--darken-1">
            Esta funcionalidade não está disponível no momento. 
            Entre em contato com seu representante para mais informações.
          </p>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";
import { VMoney } from "v-money";
import { mask } from "vue-the-mask";

export default {
  data: () => ({
    paylink: [],
    alert: false,
    valid: true,
    paymentOptionCode: "",
    cardHolderName: "",
    pan: "",
    amount: "",
    expiryMonth: "",
    expiryYear: "",
    securityCode: "",
    scheme: "",
    subscription: false,
    nameRules: [(v) => !!v || "Nome é requirido"],
    codeRules: [
      (v) => !!v || "CVC é requirido",
      (v) => (v && v.length <= 3) || "CVC precisar ser menor que 3 cacacteres.",
    ],
    amountRules: [(v) => !!v || "Valor deve ser válido"],
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
    parcels: [
      { name: "01", value: "01" },
      { name: "02", value: "02" },
      { name: "03", value: "03" },
      { name: "04", value: "04" },
      { name: "05", value: "05" },
      { name: "06", value: "06" },
      { name: "07", value: "07" },
      { name: "08", value: "08" },
      { name: "09", value: "09" },
      { name: "10", value: "10" },
      { name: "11", value: "11" },
      { name: "12", value: "12" },
    ],
    months: [
      { name: "Jan", value: "01" },
      { name: "Fev", value: "02" },
      { name: "Mar", value: "03" },
      { name: "Abr", value: "04" },
      { name: "Mai", value: "05" },
      { name: "Jun", value: "06" },
      { name: "Jul", value: "07" },
      { name: "Ago", value: "08" },
      { name: "Set", value: "09" },
      { name: "Out", value: "10" },
      { name: "Nov", value: "11" },
      { name: "Dez", value: "12" },
    ],
    years: [
      {
        name: `${new Date().getFullYear().toString()}`,
        value: `${new Date().getFullYear().toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 1).toString()}`,
        value: `${(new Date().getFullYear() + 1).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 2).toString()}`,
        value: `${(new Date().getFullYear() + 2).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 3).toString()}`,
        value: `${(new Date().getFullYear() + 3).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 4).toString()}`,
        value: `${(new Date().getFullYear() + 4).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 5).toString()}`,
        value: `${(new Date().getFullYear() + 5).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 6).toString()}`,
        value: `${(new Date().getFullYear() + 6).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 7).toString()}`,
        value: `${(new Date().getFullYear() + 7).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 8).toString()}`,
        value: `${(new Date().getFullYear() + 8).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 9).toString()}`,
        value: `${(new Date().getFullYear() + 9).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 10).toString()}`,
        value: `${(new Date().getFullYear() + 10).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 11).toString()}`,
        value: `${(new Date().getFullYear() + 11).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 12).toString()}`,
        value: `${(new Date().getFullYear() + 12).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 13).toString()}`,
        value: `${(new Date().getFullYear() + 13).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 14).toString()}`,
        value: `${(new Date().getFullYear() + 14).toString()}`,
      },
      {
        name: `${(new Date().getFullYear() + 15).toString()}`,
        value: `${(new Date().getFullYear() + 15).toString()}`,
      },
    ],
    schemes: [
      { name: "MASTERCARD", value: "MASTERCARD" },
      { name: "VISA", value: "VISA" },
      { name: "VISA_ELECTRON", value: "VISA_ELECTRON" },
      { name: "MAESTRO", value: "MAESTRO" },
      { name: "AMEX", value: "AMEX" },
    ],
  }),
  directives: { money: VMoney, mask },
  created() {
    this.$store.dispatch("system/fetchSystemConfiguration").then(() => {
      this.$store.dispatch("account/isManualSaleEnabled");
    });
    this.$store.dispatch("account/getAccount");
  },
  mounted() {
    this.$store.commit("payments/LOADING_DATA", false);
  },
  computed: {
    ...mapGetters({
      response: "payments/newPayment",
      isLoading: "payments/loadingData",
      newPaymentError: "payments/newPaymentError",
      newPaymentStatus: "payments/newPaymentStatus",
      isManualSaleEnabled: "account/isManualSaleEnabled",
    }),
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.payment = {
          subscription: this.subscription,
          verify_3ds: false,
          cardHolderName: this.cardHolderName,
          amount: this.amount.replace(/[^\d]+/g, ""),
          paymentOptionCode: this.paymentOptionCode.value,
          pan: this.pan.replace(/[^\d]+/g, ""),
          expiryMonth: this.expiryMonth.value,
          expiryYear: this.expiryYear.value,
          securityCode: this.securityCode,
          scheme: this.scheme.value,
        };
        this.$store.dispatch("payments/newPayment", this.payment);
        this.alert = this.isLoading;
        this.$refs.form.reset();
      }
    },
    updatePage() {
      window.location.reload();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style>
@font-face {
  font-family: "fontello";
  src: url("../../../assets/fonts/fontello.eot");
  src: url("../../../assets/fonts/fontello.eot?13442593#iefix")
      format("embedded-opentype"),
    url("../../../assets/fonts/fontello.woff2?13442593") format("woff2"),
    url("../../../assets/fonts/fontello.woff?13442593") format("woff"),
    url("../../../assets/fonts/fontello.ttf?13442593") format("truetype"),
    url("../../../assets/fonts/fontello.svg?13442593#fontello") format("svg");
  font-weight: normal;
  font-style: normal;
}

#cardNumber,
#securityCode {
  font-family: "fontello";
  text-transform: none;

  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */

  /* add spacing to better separate each image */
  letter-spacing: 2px;
  font-size: 10px;
}
</style>
